module.exports = __webpack_public_path__ + "img/barrier_color.1a756c9d.svg";